import React, {  useState } from "react";
import { NavLink } from "react-router-dom";
//import emailjs from "@emailjs/browser";
import "./Header.css";
import { Link } from "react-router-dom"; // Import Link


const Header = () => {
  
  const [isMenuOpen, setMenuOpen] = useState(false);
  

  const toggleMenu = () => {
    setMenuOpen(!isMenuOpen);
  };

 

  

  return (
    <header className="header">
      <div className="header-container">
        {/* Purple Band */}
        <div className="purple-band"></div>

        {/* Logo Section */}
        <div className="logo">
        <Link to="/"> {/* Wrap the logo with Link */}
    <img src="/logoz.svg" alt="OGITS Logo" />
  </Link>        </div>

        {/* Hamburger Button (Mobile) */}
        <button className="menu-toggle" onClick={toggleMenu}>
          ☰
        </button>

        {/* Navigation Menu */}
        <nav className={`nav ${isMenuOpen ? "open" : ""}`}>
          <ul className="nav-links">
            <li><NavLink to="/">Home</NavLink></li>
            <li><NavLink to="/about">About us</NavLink></li>
            <li><NavLink to="/objectives">Objectives</NavLink></li>
            <li><NavLink to="/activities">Activities</NavLink></li>
            <li><NavLink to="/WorkPrograms">Work Programs</NavLink></li>

          </ul>
        </nav>
      </div>
    </header>
  );
};

export default Header;
